import NetworkService from "./NetworkService";

export default class AdminDashboardService extends NetworkService {
  constructor() {
    super();
    this.base = "api/admin/dashboard";
  }

  bigNumbers() {
    return this.get(`${this.base}/big-numbers`);
  }
  psychologists(params) {
    return this.get(`${this.base}/psychologists`, params);
  }
  patients(params) {
    return this.get(`${this.base}/patients`, params);
  }
  appointments(params) {
    return this.get(`${this.base}/appointments`, params);
  }
  financial(params) {
    return this.get(`${this.base}/financial`, params);
  }
  actionCenter() {
    return this.get(`${this.base}/action-center`);
  }
  // Totais de psis por segmento (pills) — uma chamada só
  psyCounts(filters) {
    return this.get(`${this.base}/psy-counts`, filters);
  }
}
